

















































import Vue, { PropType } from 'vue';

import { GoogleClassroomCourse } from '@/api/auth/google';

export default Vue.extend({
  props: {
    courses: {
      type: Array as PropType<GoogleClassroomCourse[]>,
      required: true
    },

    activeAliases: {
      type: Array as PropType<string[]>,
      required: true
    }
  },

  computed: {
    available(): GoogleClassroomCourse[] {
      return this.courses.filter(
        c =>
          !this.activeAliases.includes(`g:${c.id}`) &&
          c.courseState === 'ACTIVE'
      );
    },

    inUse(): GoogleClassroomCourse[] {
      return this.courses.filter(c => this.activeAliases.includes(`g:${c.id}`));
    }
  },

  methods: {
    select(course: GoogleClassroomCourse) {
      this.$emit('select', course);
    }
  }
});
